// @flow
import * as React from 'react';
import Radium from 'radium';
import classNames from 'classnames';

import { Sizes, Spacing } from 'utils/styleguide';

type Props = {
  icon: string,
  color: string,
  text: string,
};

class IconText extends React.Component<Props> {
  render() {
    const { icon, color, text } = this.props;
    return (
      <span style={styles.root}>
        <span style={styles.content}>
          <span
            style={styles.icon}
            className={classNames(icon, `bg-${color}`)}
          />
          <span style={styles.text} className={`text-${color}`}>
            {text}
          </span>
        </span>
      </span>
    );
  }
}

const styles = {
  root: {
    display: 'inline-block',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    backgroundColor: 'pink',
    width: Sizes.Small,
    height: Sizes.Small,
  },
  text: {
    paddingLeft: Spacing.Nano,
    paddingRight: Spacing.Nano,
    paddingTop: Spacing.YourPenis / 2,
    paddingBottom: Spacing.YourPenis / 2,
    fontWeight: 'bold',
  },
};

export default Radium(IconText);



// WEBPACK FOOTER //
// ./src/components/IconText/IconText.js